import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_footwear_men: FaireCategoryEntity = {
  token: "cat_footwear-men",
  type: "category",
  name: "Men",
  level: 2,
  parentToken: "cat_footwear",
  href: "/category/footwear/men",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
